<template>
    <div class="custom-checkbox">
        <label class="checkbox-label">
            <input v-model="localChecked" @change="emitChange" type="checkbox" class="checkbox-input">
            <span :class="{ active: localChecked }" class="checkbox-text">{{ label }}</span>
        </label>
    </div>
</template>

<script>
export default {
    props: ['is_checked', 'label'],
    data() {
        return {
            localChecked: this.is_checked
        }
    },
    watch: {
        is_checked(newVal) {
            this.localChecked = newVal;
        }
    },
    methods: {
        emitChange() {
            this.$emit('CheckChange', this.localChecked);
        }
    }
}
</script>
<style lang="scss">
.custom-checkbox {
    margin: 6px 0;
    
    .checkbox-label {
        display: flex;
        align-items: center;
        cursor: pointer;
        padding: 4px 6px;
        margin-left: -6px;
        border-radius: 8px;
        transition: background-color 0.2s ease;

        &:hover {
            background-color: #f1f5f9;
            
            .checkbox-input {
                border-color: #64748b;
            }
            .checkbox-text {
                color: #0f172a;
            }
        }
    }
    
    .checkbox-input {
        appearance: none;
        margin: 0;
        font: inherit;
        width: 1.25em;
        height: 1.25em;
        border: 1.5px solid #94a3b8;
        border-radius: 6px;
        display: grid;
        place-content: center;
        transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
        cursor: pointer;
        background-color: #ffffff;
    }
    
    .checkbox-input:checked {
        border-color: #3b82f6;
        background-color: #3b82f6;
        background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6 10.2L3.5 7.7L2.5 8.7L6 12.2L14 4.2L13 3.2L6 10.2Z'/%3E%3C/svg%3E");
        background-size: 80% 80%;
        background-position: center;
        background-repeat: no-repeat;
    }

    .checkbox-input:focus-visible {
        outline: 2px solid #93c5fd;
        outline-offset: 2px;
    }
    
    .checkbox-text {
        display: block;
        margin-left: 10px;
        font-family: Outfit, sans-serif;
        font-size: 14px;
        font-weight: 400;
        color: #475569;
        transition: color 0.2s ease;
        user-select: none;

        &.active {
            font-weight: 500;
            color: #1e293b;
        }
    }
}
</style>
